import Network from './Network';

class BathAddonLocationsService {
	static async create(payload) {
		const response = await Network.request({
			method: 'POST',
			url: '/admin/bath-addon-locations',
			data: payload,
		});
		return response.data;
	}

	static async update(id, payload) {
		const response = await Network.request({
			method: 'PUT',
			url: `/admin/bath-addon-locations/${id}`,
			data: payload,
		});
		return response.data;
	}

	static async delete(id) {
		const response = await Network.request({
			method: 'DELETE',
			url: `/admin/bath-addon-locations/${id}`,
		});
		return response.data;
	}
}

export default BathAddonLocationsService;
